(function () {
    'use strict';

    angular.module('document')
        .directive('documentList', documentList);

    function documentList() {
        return {
            restrict: 'E',
            templateUrl: 'layout/documentListTemplate.html',
            scope: {
                object: '=',
                onSuccess: '&'
            },
            controller: directiveController
        };
    }

    function directiveController($scope, DocumentService, DocumentConfigService, dialogService, userService) {
        init();
        $scope.$on('refreshDocuments', reloadData);
        $scope.enableDelete = userService.canEditObject($scope.object.createdByCurrentUser);

        var currentDialog = document.getElementById('document-dialog');

        function init() {
            $scope.documents = [];
            $scope.loading = true;
            $scope.config = DocumentConfigService;
            reloadData();
        }

        function reloadData() {
            DocumentService.getDocumentList($scope.object.id, function (data) {
                $scope.documents = data;
                $scope.object.dokumentuKiekis = data.length;
                $scope.loading = false;
            }, function () {
                dialogService.error('Įvyko klaida kraunant dokumentų sąrašą.');
                $scope.loading = false;
            });
        }

        $scope.removeDocument = function (fileName) {
            dialogService.confirm('Ar tikrai norite ištrinti ' + fileName + '?', null, 'Trinti')
                .then(function () {
                    DocumentService.deleteDocument($scope.object.id, fileName, function (data) {
                        switch (data.status) {
                            case 'ERROR':
                                dialogService.error('Įvyko klaida trinant dokumentą.');
                                break;
                            case 'NOT_FOUND':
                                dialogService.error('Dokumentas nerastas.');
                                break;
                        }
                        reloadData();
                        if ($scope.onSuccess) {
                            $scope.onSuccess();
                        }
                    }, function () {
                        dialogService.error('Įvyko klaida trinant dokumentą.');
                    });
                });
        }

        currentDialog.addEventListener('dragover', function (e) { // checking if can drag file drom dekstop
            e = e || event;
            if (e.target.id != 'document-input-image') {
                e.preventDefault();
                e.dataTransfer.effectAllowed = 'none';
                e.dataTransfer.dropEffect = 'none';
            }
        }, false);

        currentDialog.addEventListener('drop', function (e) { // checking if can drop file drom dekstop
            e = e || event;
            if (e.target.id != 'document-input-image') {
                e.preventDefault();
                e.dataTransfer.effectAllowed = 'none';
                e.dataTransfer.dropEffect = 'none';
            }
        }, false);


        $scope.$watch('files', function () {
            $scope.upload($scope.files);
        });

        $scope.upload = function (files) {
            if (files && files.length) {
                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    DocumentService.uploadDocuments($scope.object.id, $scope.inputElement, file, false, $scope.onSuccess);
                }
            }
        };

        $scope.canDeleteDocument = function(document) {
            return userService.canEditObject(document.createdByCurrentUser);
        }
    }
})();
